/** Single rename point when the product gets a brand name. */
export const SDK_NAME = "cmp";

export const TC_COOKIE = "euconsent-v2";
export const CONSENT_COOKIE = "cmp_consent";
export const META_COOKIE = "cmp_meta";
export const GPP_COOKIE = "cmp_gpp";
